import { render, staticRenderFns } from "./AppProductDetails.vue?vue&type=template&id=218fef47&scoped=true"
import script from "./AppProductDetails.vue?vue&type=script&lang=js"
export * from "./AppProductDetails.vue?vue&type=script&lang=js"
import style0 from "./AppProductDetails.vue?vue&type=style&index=0&id=218fef47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218fef47",
  null
  
)

export default component.exports